import { ACCOUNTING_URL, JSONAPI_URL } from "../../../services/common-urls";
import { HttpClient, MHTTPCL, JSON_STRING, createHttpGetOptions, jsonToFormData } from "../../../services/http/http-client";
export const DISTRIBUTION_URL = '/distribution.pl';
const DASHBOARD = 'dashboard'
export const DashboardService = {
  getDashboardData: () => HttpClient.get(DISTRIBUTION_URL, {
    section: DASHBOARD,
    action: "home",
    output: "json",
  }),

}